<svg
  class="estimate-chart"
  [attr.viewBox]="'0 0 ' + chartWidth + ' ' + chartHeight()"
  role="img"
  [attr.aria-label]="ariaLabel()"
  [class.compact]="displayMode() === 'compact'"
>
  @if (paths(); as p) {
    <g aria-hidden="true">
      <!-- Plot background -->
      <rect
        class="plot-bg"
        [attr.x]="p.plotLeft"
        [attr.y]="p.plotTop"
        [attr.width]="p.plotRight - p.plotLeft"
        [attr.height]="p.plotBottom - p.plotTop"
      />

      <!-- Horizontal grid + Y labels -->
      @for (tick of p.yTicks; track tick.value) {
        <line
          class="grid-line"
          [attr.x1]="p.plotLeft"
          [attr.x2]="p.plotRight"
          [attr.y1]="tick.y"
          [attr.y2]="tick.y"
        />
        <text class="axis-label y-label" [attr.x]="p.plotLeft - 10" [attr.y]="tick.y + 4">
          {{ tick.label }}
        </text>
      }

      <!-- Axes -->
      <line
        class="axis-line"
        [attr.x1]="p.plotLeft"
        [attr.x2]="p.plotLeft"
        [attr.y1]="p.plotTop"
        [attr.y2]="p.plotBottom"
      />
      <line
        class="axis-line"
        [attr.x1]="p.plotLeft"
        [attr.x2]="p.plotRight"
        [attr.y1]="p.plotBottom"
        [attr.y2]="p.plotBottom"
      />

      <!-- Axis titles -->
      <text
        class="axis-title y-axis-title"
        [attr.transform]="
          'translate(14 ' + (p.plotTop + p.plotBottom) / 2 + ') rotate(-90)'
        "
      >
        Est. Net Price
      </text>
      <text
        class="axis-title x-axis-title"
        [attr.x]="(p.plotLeft + p.plotRight) / 2"
        [attr.y]="p.plotBottom + 40"
      >
        Family income
      </text>

      <!-- X labels -->
      @for (tick of p.xTicks; track tick.value) {
        <text class="axis-label x-label" [attr.x]="tick.x" [attr.y]="p.plotBottom + 18">
          {{ tick.label }}
        </text>
      }

      <!-- Likely range band + boundary strokes -->
      <path class="range-band" [attr.d]="p.bandPath" [attr.fill]="accentColor()" />
      <path
        class="range-edge"
        [attr.d]="p.rangeHighPath"
        [attr.stroke]="accentColor()"
        fill="none"
      />
      <path
        class="range-edge"
        [attr.d]="p.rangeLowPath"
        [attr.stroke]="accentColor()"
        fill="none"
      />

      <!-- Central estimate -->
      <path
        class="central-line"
        [attr.d]="p.centralPath"
        [attr.stroke]="accentColor()"
        fill="none"
      />

      <!-- Published cost of attendance -->
      <line
        class="coa-line"
        [attr.x1]="p.plotLeft"
        [attr.x2]="p.plotRight"
        [attr.y1]="p.coaY"
        [attr.y2]="p.coaY"
      />
      <text
        class="coa-label"
        [attr.x]="p.coaLabelX"
        [attr.y]="p.coaLabelY"
        text-anchor="end"
      >
        Published cost {{ p.coaDisplay | currency: 'USD' : 'symbol' : '1.0-0' }}
      </text>

      <!-- Selected income guide -->
      <line
        class="income-guide"
        [attr.x1]="p.selectedX"
        [attr.x2]="p.selectedX"
        [attr.y1]="p.plotTop"
        [attr.y2]="p.plotBottom"
        [attr.stroke]="accentColor()"
      />
      <circle
        class="selected-point-ring"
        [attr.cx]="p.selectedX"
        [attr.cy]="p.selectedY"
        r="7"
        fill="#fff"
      />
      <circle
        class="selected-point"
        [attr.cx]="p.selectedX"
        [attr.cy]="p.selectedY"
        r="4.5"
        [attr.fill]="accentColor()"
      />

      <!-- Selection callout -->
      <g class="callout" [attr.transform]="'translate(' + p.calloutX + ' ' + p.calloutY + ')'">
        <rect
          class="callout-bg"
          x="0"
          y="0"
          [attr.width]="p.calloutWidth"
          [attr.height]="p.calloutHeight"
          rx="6"
        />
        <text class="callout-value" x="12" y="22" [attr.fill]="accentColor()">
          {{ result().central | currency: 'USD' : 'symbol' : '1.0-0' }}/yr
        </text>
        <text class="callout-range" x="12" y="40">
          Likely
          {{ result().rangeLow | currency: 'USD' : 'symbol' : '1.0-0' }}–{{
            result().rangeHigh | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </text>
      </g>
    </g>
  }
</svg>
